<template>
  <div class="liu pos-manage businesser">
    <!-- 页面头部 -->
    <mt-header fixed title="新增业务员" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 上部账号信息 -->
      <div class="form bn-form mt-15">
        <!-- 标题 -->
        <div class="title bn-form-row row-title">
          <span>账号信息</span>
        </div>
        <!-- 账号角色 -->
        <div class="row bn-form-row" @click="popup.visible=true">
          <div class="item">
            <div class="label">
              <span>{{ data.userRole.label }}</span>
            </div>
            <div class="content sheet" :class="{'selected':data.userRole.value!=='请选择'}">
              <span>{{ data.userRole.value }}</span>
              <div class="arrow" v-show="data.userRole.mult" />
            </div>
          </div>
        </div>
        <!-- 业务员名 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userName.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="data.userName.value" maxlength="15" :placeholder="data.userName.placeholder">
            </div>
          </div>
        </div>
        <!-- 业务员手机号 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userMobile.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="data.userMobile.value" :placeholder="data.userMobile.placeholder" @keyup="onUserMobileInput">
            </div>
          </div>
        </div>
        <!-- 登录密码 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userPwd1.label }}</span>
            </div>
            <div class="content">
              <input class="pwd" :type="pwd1Type" v-model="data.userPwd1.value" :placeholder="data.userPwd1.placeholder" @keyup="onUserPwd1Input">
              <div class="scan" @click="onPwd1EyeClick">
                <svg-icon :icon-class="pwd1Eye" class-name="cur-icon"></svg-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- 登录密码确认 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>{{ data.userPwd2.label }}</span>
            </div>
            <div class="content">
              <input class="pwd" :type="pwd2Type" v-model="data.userPwd2.value" :placeholder="data.userPwd2.placeholder" @keyup="onUserPwd2Input">
              <div class="scan" @click="onPwd2EyeClick">
                <svg-icon :icon-class="pwd2Eye" class-name="cur-icon"></svg-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 下部身份信息 -->
      <div class="form bn-form mt-15">
        <!-- 标题 -->
        <div class="title bn-form-row row-title">
          <span>身份信息</span>
        </div>
        <!--证件照 -->
        <div class="row bn-form-row">
          <div class="item">
            <div class="label">
              <span>证件照</span>
            </div>
            <div class="content ">
              <div class="id-picture">
                <div class="picture-item">
                  <div class="picture-item-img" @click="$refs.camera.imgClick('renXiang')">
                    <img v-if="data.idCardFront.value" :src="data.idCardFront.value" alt="">
                    <svg-icon v-else icon-class="authenticate-headshot" class-name="item-svg"></svg-icon>
                  </div>
                  <div class="picture-item-label">
                    <span>{{ data.idCardFront.label }}</span>
                  </div>
                </div>
                <div class="picture-item">
                  <div class="picture-item-img" @click="$refs.camera.imgClick('guoHui')">
                    <img v-if="data.idCardBack.value" :src="data.idCardBack.value" alt="">
                    <svg-icon v-else icon-class="authenticate-emblem" class-name="item-svg"></svg-icon>
                  </div>
                  <div class="picture-item-label">
                    <span>{{ data.idCardBack.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 姓名 -->
        <div class="row bn-form-row" v-if="cardFrontFinish">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardName.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="data.idCardName.value" maxlength="15" :placeholder="data.idCardName.placeholder">
            </div>
          </div>
        </div>
        <!-- 身份证号 -->
        <div class="row bn-form-row" v-if="cardFrontFinish">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardNumber.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="data.idCardNumber.value" maxlength="20" :placeholder="data.idCardNumber.placeholder" @keyup="onIdCardNumberInput">
            </div>
          </div>
        </div>
        <!-- 有效开始日期 -->
        <div class="row bn-form-row" v-if="cardBackFinish" @click="onDatePickerItemClick('idCardStartDate')">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardStartDate.label }}</span>
            </div>
            <div class="content sheet" :class="{'selected':data.idCardStartDate.value!=='请选择'}">
              <span>{{ data.idCardStartDate.value }}</span>
              <div class="arrow" />
            </div>
          </div>
        </div>
        <!-- 有效截止日期 -->
        <div class="row bn-form-row" v-if="cardBackFinish" @click="onDatePickerItemClick('idCardEndDate')">
          <div class="item">
            <div class="label">
              <span>{{ data.idCardEndDate.label }}</span>
            </div>
            <div class="content sheet" :class="{'selected':data.idCardEndDate.value!=='请选择'}">
              <span class="link" @click.stop="onIdCardEndDateBtnClick">长期</span>
              <span>{{ data.idCardEndDate.value }}</span>
              <div class="arrow" />
            </div>
          </div>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div class="btn">
        <mt-button type="primary" size="large" @click="onAddSubmitClick">
          提交
        </mt-button>
      </div>
    </div>
    <!-- 弹出框组件 -->
    <mt-popup class="bn-popup" v-model="popup.visible" :modal="true">
      <div class="popup-frame">
        <div class="popup-title">
          <span>选择账号角色</span>
        </div>
        <div class="popup-item" v-for="(item, index) in popup.userRoleArr" :key="index" @click="onUserRoleItemClick(item)">
          <span>{{ item.name }}</span>
        </div>
        <div class="popup-btn" @click="popup.visible=false">
          <span>取消</span>
        </div>
      </div>
    </mt-popup>
    <!-- 日期控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
    <!-- 相机组件 -->
    <camera ref="camera" @getImgInfo="getCameraImgInfo" />
  </div>
</template>

<script>
import { upLoadImgForAgent, formatDateId } from '@/utils/utils';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetIdCardInformation, InsertSalesman, GetSalesmanType } from '@/api/customer';
import { controlMobileInput, controlLicenseNoInput, controlIdCardInput } from '@/utils/format';
import { validateEmpty, validateMobile, validatePassword, validateIdCard } from '@/utils/validate';
import camera from '@/components/camera';

export default {
  name: 'BusinesserAdd',
  components: { camera },
  data() {
    return {
      pwd1Eye: 'hide_money',
      pwd1Type: 'password',
      pwd2Eye: 'hide_money',
      pwd2Type: 'password',
      cardFrontFinish: false,
      cardBackFinish: false,
      data: {
        userRole: { label: '账号角色', value: '请选择', id: '', placeholder: '', mult: true },
        userName: { label: '业务员名', value: '', placeholder: '请输入业务员名' },
        userMobile: { label: '业务员手机号', value: '', placeholder: '请输入业务员手机号' },
        userPwd1: { label: '登录密码', value: '', placeholder: '请设置6位以上数字或字母' },
        userPwd2: { label: '登录密码', value: '', placeholder: '请确认登录密码' },
        idCardFront: { label: '头像面', value: '', placeholder: '' },
        idCardBack: { label: '国徽面', value: '', placeholder: '' },
        idCardName: { label: '姓名', value: '', sex: '', birthday: '', nationality: '', address: '', office: '', placeholder: '请输入身份证姓名' },
        idCardNumber: { label: '身份证号', value: '', placeholder: '请输入身份证号' },
        idCardStartDate: { label: '有效开始日期', value: '请选择', placeholder: '' },
        idCardEndDate: { label: '有效截止日期', value: '请选择', placeholder: '' },
      },
      popup: {
        visible: false,
        userRoleArr: [],
      },
      picker: {
        parent: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: new Date(),
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getSalesmanType();
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 通过接口获取账号角色列表
    getSalesmanType(callback) {
      CusLoadingOpen();
      GetSalesmanType()
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.popup.userRoleArr.push(...res.rows);
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口新增业务员
    insertSalesman(callback) {
      CusLoadingOpen();
      const data = {
        name: this.data.userName.value,
        address: this.data.idCardName.address,
        birthday: this.data.idCardName.birthday,
        dateOfInvalid: this.data.idCardEndDate.value,
        dateOfIssue: this.data.idCardStartDate.value,
        familyName: this.data.idCardName.nationality,
        idCardName: this.data.idCardName.value,
        idCardNum: this.data.idCardNumber.value.replace(/\s/gi, ''),
        idcardBackUrl: this.data.idCardBack.value,
        idcardFrontUrl: this.data.idCardFront.value,
        mobile: this.data.userMobile.value.replace(/\s/gi, ''),
        office: this.data.idCardName.office,
        passWord: this.data.userPwd2.value,
        sex: this.data.idCardName.sex,
        type: this.data.userRole.id,
      };
      InsertSalesman(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 验证当前页面数据合法性
    validateInsertData(callback) {
      const userRoleErr = validateEmpty(this.data.userRole.value);
      const userNameErr = validateEmpty(this.data.userName.value);
      const userMobileErr = validateMobile(this.data.userMobile.value);
      const userPwd1Err = validatePassword(this.data.userPwd1.value);
      const userPwd2Err = this.data.userPwd2.value !== this.data.userPwd1.value ? 1 : 0;
      const idCardFrontErr = validateEmpty(this.data.idCardFront.value);
      const idCardBackErr = validateEmpty(this.data.idCardBack.value);
      const idCardNameErr = validateEmpty(this.data.idCardName.value);
      const idCardNumberErr = validateIdCard(this.data.idCardNumber.value);
      const idCardStartDateErr = validateEmpty(this.data.idCardStartDate.value);
      const idCardEndDateErr = validateEmpty(this.data.idCardEndDate.value);

      const errResult1 = !userRoleErr && !userNameErr && !userMobileErr;
      const errResult2 = !userPwd1Err && !userPwd2Err && !idCardFrontErr;
      const errResult3 = !idCardBackErr && !idCardNameErr && !idCardNumberErr;
      const errResult4 = !idCardStartDateErr && !idCardEndDateErr;
      if (errResult1 && errResult2 && errResult3 && errResult4) {
        callback && callback();
      } else {
        if (userRoleErr) {
          CusToast(`${this.data.userRole.label}不能为空`);
          return;
        }
        if (userNameErr) {
          CusToast(`${this.data.userName.label}不能为空`);
          return;
        }
        if (userMobileErr === 1) {
          CusToast(`${this.data.userMobile.label}不能为空`);
          return;
        }
        if (userMobileErr === 2) {
          CusToast(`${this.data.userMobile.label}格式不正确`);
          return;
        }
        if (userPwd1Err === 1) {
          CusToast(`${this.data.userPwd1.label}不能为空`);
          return;
        }
        if (userPwd1Err === 2) {
          CusToast(`${this.data.userPwd1.label}必须是6位以上数字/字母`);
          return;
        }
        if (userPwd1Err === 3) {
          CusToast(`${this.data.userPwd1.label}不能是重复的数字`);
          return;
        }
        if (userPwd1Err === 4) {
          CusToast(`${this.data.userPwd1.label}不能是连续的数字`);
          return;
        }
        if (userPwd2Err) {
          CusToast(`两次密码输入的不一致`);
          return;
        }
        if (idCardFrontErr) {
          CusToast(`必须上传身份证${this.data.idCardFront.label}照片`);
          return;
        }
        if (idCardBackErr) {
          CusToast(`必须上传身份证${this.data.idCardBack.label}照片`);
          return;
        }
        if (idCardNameErr) {
          CusToast(`${this.data.idCardName.label}不能为空`);
          return;
        }
        if (idCardNumberErr === 1) {
          CusToast(`${this.data.idCardNumber.label}不能为空`);
          return;
        }
        if (idCardNumberErr === 2) {
          CusToast(`${this.data.idCardNumber.label}格式不正确`);
          return;
        }
        if (idCardStartDateErr) {
          CusToast(`${this.data.idCardStartDate.label}不能为空`);
          return;
        }
        if (idCardEndDateErr) {
          CusToast(`${this.data.idCardEndDate.label}不能为空`);
          return;
        }
      }
    },
    // 通过接口上传图片服务器并返回图片信息
    getCameraImgInfo(info) {
      upLoadImgForAgent(info.blob, info.base64, info.type, res => {
        switch (info.type) {
          case 'renXiang':
            this.data.idCardFront.value = res.data;
            this.getIdCardInformation(res.data, 1);
            break;
          case 'guoHui':
            this.data.idCardBack.value = res.data;
            this.getIdCardInformation(res.data, 2);
            break;
        }
      });
    },
    // 通过接口获取身份证正反面信息
    getIdCardInformation(imgUrl, side) {
      CusLoadingOpen();
      GetIdCardInformation({ imgUrl, side })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res && res.data) {
                if (side === 1) {
                  this.cardFrontFinish = true;
                  this.data.idCardName.value = res.data.name;
                  this.data.idCardName.sex = res.data.sex;
                  this.data.idCardName.birthday = res.data.birthday;
                  this.data.idCardName.nationality = res.data.nationality;
                  this.data.idCardName.address = res.data.address;
                  this.data.idCardNumber.value = res.data.idCardNum;
                } else {
                  this.cardBackFinish = true;
                  this.data.idCardName.office = res.data.office;
                  this.data.idCardStartDate.value = res.data.dateOfIssue;
                  this.data.idCardEndDate.value = res.data.dateOfInvalid;
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回单击事件
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 密码1眼睛点击事件
    onPwd1EyeClick() {
      if (this.pwd1Eye === 'hide_money') {
        this.pwd1Eye = 'show_money';
        this.pwd1Type = 'text';
      } else {
        this.pwd1Eye = 'hide_money';
        this.pwd1Type = 'password';
      }
    },
    // 密码2眼睛点击事件
    onPwd2EyeClick() {
      if (this.pwd2Eye === 'hide_money') {
        this.pwd2Eye = 'show_money';
        this.pwd2Type = 'text';
      } else {
        this.pwd2Eye = 'hide_money';
        this.pwd2Type = 'password';
      }
    },
    // 账号角色单击事件
    onUserRoleItemClick(val) {
      this.$nextTick(() => {
        this.data.userRole.value = val.name;
        this.data.userRole.id = val.type;
        this.popup.visible = false;
      });
    },
    // 业务员手机号输入事件
    onUserMobileInput() {
      this.data.userMobile.value = controlMobileInput(this.data.userMobile.value);
    },
    // 登录密码输入事件
    onUserPwd1Input() {
      this.data.userPwd1.value = controlLicenseNoInput(this.data.userPwd1.value);
    },
    // 登录密码确认输入事件
    onUserPwd2Input() {
      this.data.userPwd2.value = controlLicenseNoInput(this.data.userPwd2.value);
    },
    // 身份证号输入事件
    onIdCardNumberInput() {
      this.data.idCardNumber.value = controlIdCardInput(this.data.idCardNumber.value);
    },
    // 身份证有效日期点击事件
    onDatePickerItemClick(val) {
      this.picker.parent = val;
      switch (val) {
        // 身份证/营业执照-开始日期
        case 'idCardStartDate':
          // 日期框显示的最大日期：1900-01-01
          this.picker.startDate = new Date('1900-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          break;
        // 身份证/营业执照-结束日期
        case 'idCardEndDate':
          // 日期框显示的最大日期：今天
          this.picker.startDate = new Date();
          // 日期框显示的最小日期：2305-12-31
          this.picker.endDate = new Date('2355-12-31');
          break;
      }
      this.$refs.datePicker.open();
    },
    // 身份证有效日期长期按钮点击事件
    onIdCardEndDateBtnClick() {
      this.data.idCardEndDate.value = '长期';
    },
    onDatePickerConfirm(val) {
      if (this.picker.parent === 'idCardStartDate') {
        this.data.idCardStartDate.value = formatDateId(val);
      }
      if (this.picker.parent === 'idCardEndDate') {
        this.data.idCardEndDate.value = formatDateId(val);
      }
    },
    // 业务员添加提交按钮点击事件
    onAddSubmitClick() {
      this.$nextTick(() => {
        this.validateInsertData(() => {
          this.insertSalesman(() => {
            CusToast('添加成功', 1800);
            setTimeout(() => {
              this.$router.go(-1);
            }, 1900);
          });
        });
      });
    },
  },
};
</script>
